import { Link } from "react-router-dom";
import { Logo } from "./Navbar";
import { EMAIL, OFFICE, PHONE_DISPLAY, PHONE_LINK, WHATSAPP_LINK } from "../data/site";

export const Footer = () => (
  <footer data-testid="site-footer" className="bg-navy-deep text-white">
    <div className="mx-auto max-w-7xl px-5 sm:px-8 py-16 sm:py-20 grid gap-12 md:grid-cols-3 items-start">
      <div>
        <Logo light />
        <p className="mt-6 text-sm leading-relaxed text-white/60 max-w-xs">
          Parsn Construction and Developers Private Limited — building across Mumbai, Pune, Chennai
          and Saudi Arabia since 1971.
        </p>
      </div>
      <nav className="flex flex-col gap-3" aria-label="Footer">
        <span className="text-xs font-semibold uppercase tracking-[0.25em] text-white/40 mb-2">Explore</span>
        <Link data-testid="footer-link-home" to="/" className="text-sm text-white/80 hover:text-white transition-colors duration-300">Home</Link>
        <Link data-testid="footer-link-projects" to="/projects" className="text-sm text-white/80 hover:text-white transition-colors duration-300">Ongoing Projects</Link>
        <Link data-testid="footer-link-track-record" to="/track-record" className="text-sm text-white/80 hover:text-white transition-colors duration-300">Track Record</Link>
        <Link data-testid="footer-link-about" to="/about" className="text-sm text-white/80 hover:text-white transition-colors duration-300">About</Link>
        <Link data-testid="footer-link-careers" to="/careers" className="text-sm text-white/80 hover:text-white transition-colors duration-300">Careers</Link>
        <Link data-testid="footer-link-contact" to="/contact" className="text-sm text-white/80 hover:text-white transition-colors duration-300">Contact</Link>
      </nav>
      <div className="flex flex-col gap-3">
        <span className="text-xs font-semibold uppercase tracking-[0.25em] text-white/40 mb-2">Reach us</span>
        <a data-testid="footer-phone" href={PHONE_LINK} className="text-sm text-white/80 hover:text-white transition-colors duration-300">{PHONE_DISPLAY}</a>
        <a data-testid="footer-email" href={`mailto:${EMAIL}`} className="text-sm text-white/80 hover:text-white transition-colors duration-300">{EMAIL}</a>
        <a data-testid="footer-whatsapp" href={WHATSAPP_LINK} target="_blank" rel="noopener noreferrer" className="text-sm text-white/80 hover:text-white transition-colors duration-300">WhatsApp us — 77383 84698</a>
        <span className="text-sm text-white/60">{OFFICE}</span>
      </div>
    </div>
    <div className="border-t border-white/10">
      <div className="mx-auto max-w-7xl px-5 sm:px-8 py-6 flex flex-col sm:flex-row gap-2 sm:items-center sm:justify-between">
        <p className="text-xs text-white/40">© {new Date().getFullYear()} Parsn Group. All rights reserved.</p>
      </div>
    </div>
  </footer>
);
